import { render, staticRenderFns } from "./MyAccountArtworkActions.vue?vue&type=template&id=1436fc62"
import script from "./MyAccountArtworkActions.vue?vue&type=script&lang=js"
export * from "./MyAccountArtworkActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports